import React from 'react';
import PropTypes from 'prop-types';

import ApplicationId from './ApplicationId';

const PageHeader = ({ route }) => route.image ? (
  <div className={!!route.name ? 'mb-6' : 'mb-4'}>
    <div className="header-image absolute overflow-hidden top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[72px] h-[72px] bg-white rounded-full border border-blue-200 flex items-center justify-center">
      {route.image && (
        <img alt={route.name} className="w-full h-full object-contain" src={route.image} />
      )}
    </div>
    <ApplicationId marginBottom={!!route.title ? '0' : '4'} />
    <div className="flex items-center justify-center gap-2 mb-2">
      <h2 className="page-title text-xl md:text-2xl text-center font-semibold text-slate-800 leading-tight">
        {route.title && (
          <span className="block font-bold">
            {route.title}
          </span>
        )}
        {route.name}
      </h2>
      {route.tooltip}
    </div>
    {route.description && (
      <p className="text-sm text-center text-slate-600">
        {route.description}
      </p>
    )}
  </div>
) : <ApplicationId marginBottom="6" />;

PageHeader.propTypes = {
  route: PropTypes.object.isRequired,
};

export default PageHeader;
